import React from "react";

const RegistrationFormProgressBar = props => {
  let explanation = "";
  switch (props.step) {
    case 1:
      explanation = "Schritt 1 von 3: Deine Informationen";
      break;
    case 2:
      explanation = "Schritt 2 von 3: Dein Produkt";
      break;
    case 3:
      explanation = "Schritt 3 von 3: Abschluss der Registrierung";
      break;
    default:
      break;
  }

  return (
    <div className="registrationFormProgressBar text-center">
      <p className="subtitle">{explanation}</p>
      <div
        className={`progressBarPart ${props.step === 1 ? "blue" : "grey"}`}
      />
      <div
        className={`progressBarPart ${props.step === 2 ? "blue" : "grey"}`}
      />
      <div
        className={`progressBarPart ${props.step === 3 ? "blue" : "grey"}`}
      />
    </div>
  );
};

export default RegistrationFormProgressBar;
